/**
 * MVの高さまでスクロールしたらヘッダーにactiveクラスを付与する
 */
const headerScrollActive = () => {
  const headerElement = document.getElementById('js-header');
  if (!headerElement) {
    return;
  }

  // MV要素を取得（フロントページ: .m-home-mv、サブページ: .m-sub-mv）
  const mvElement =
    document.querySelector('.m-home-mv') ||
    document.querySelector('.m-sub-mv');

  if (!mvElement) {
    return;
  }

  const checkScroll = () => {
    const scrollY = window.scrollY || window.pageYOffset;
    const mvHeight = mvElement.offsetHeight;

    if (scrollY >= mvHeight) {
      headerElement.classList.add('active');
    } else {
      headerElement.classList.remove('active');
    }
  };

  // 初期チェック
  checkScroll();

  // スクロールイベント（パフォーマンス最適化のためthrottle）
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        checkScroll();
        ticking = false;
      });
      ticking = true;
    }
  });

  // リサイズ時にも再チェック（MVの高さが変わる可能性があるため）
  window.addEventListener('resize', () => {
    checkScroll();
  });
};

export { headerScrollActive };

